<template>
  <div class="feed">
    <FeedItem v-for="paper in papers" :key="paper.title" :paper="paper" />
  </div>
</template>

<script>
import { db } from '@/main';
import FeedItem from '@/components/FeedItem.vue';

export default {
  name: 'Feed',
  components: {
    FeedItem
  },
  data() {
    return {
      papers: [],
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      var papers = [];
      db.collection('papers').limit(100).get().then((querySnapshot) => {
        querySnapshot.forEach(function(doc) {
          var docData = doc.data();
          docData.id = doc.id;
          papers.push(docData);
        });
        this.papers = papers;
      });
    }
  }
};
</script>